import { useState } from "react";
import { api } from "../api.ts";
import { BottomSheet } from "./BottomSheet.tsx";

interface Props {
  readonly field: "phone" | "email";
  readonly onSaved: () => void;
  readonly onClose: () => void;
}

export function EditProfileSheet({ field, onSaved, onClose }: Props) {
  const [value, setValue] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const save = async () => {
    const trimmed = value.trim();
    if (!trimmed) { setError(`Enter your ${field === "phone" ? "phone number" : "email"}`); return; }

    if (field === "phone") {
      const digits = trimmed.replace(/\D/g, "");
      if (digits.length !== 10) { setError("Enter a valid 10-digit number"); return; }
      setSaving(true);
      setError(null);
      try {
        await api.updateProfile({ phone: `+91${digits}` });
        onSaved();
      } catch { setError("Could not update. Try again."); }
      finally { setSaving(false); }
    } else {
      if (!trimmed.includes("@") || trimmed.length < 5) { setError("Enter a valid email"); return; }
      setSaving(true);
      setError(null);
      try {
        await api.updateProfile({ email: trimmed.toLowerCase() });
        onSaved();
      } catch { setError("Could not update. Try again."); }
      finally { setSaving(false); }
    }
  };

  return (
    <BottomSheet title={field === "phone" ? "Add phone number" : "Add email"} onClose={onClose}>
      <div className="ds-field">
        <label className="ds-label" htmlFor="edit-value">
          {field === "phone" ? "Mobile number" : "Email address"}
        </label>
        {field === "phone" ? (
          <div style={{ display: "flex", gap: "var(--ds-space-2)" }}>
            <span className="ds-input" style={{
              width: 52, flexShrink: 0, display: "flex", alignItems: "center",
              justifyContent: "center", fontWeight: 600,
            }}>+91</span>
            <input className="ds-input" id="edit-value" type="tel" inputMode="numeric"
              placeholder="9876543210" maxLength={10}
              value={value} onChange={(e) => setValue(e.target.value.replace(/\D/g, ""))}
              style={{ flex: 1 }} />
          </div>
        ) : (
          <input className="ds-input" id="edit-value" type="email"
            placeholder="name@email.com"
            value={value} onChange={(e) => setValue(e.target.value)} />
        )}
      </div>

      {error && <p className="ds-hint ds-hint--error" style={{ marginTop: "var(--ds-space-2)" }}>{error}</p>}

      <button className="ds-btn ds-btn--primary ds-btn--lg ds-btn--block"
        style={{ marginTop: "var(--ds-space-4)" }}
        disabled={saving} onClick={save}>
        {saving ? "Saving..." : "Save"}
      </button>
    </BottomSheet>
  );
}
